export function _e(key, defaultValue) {
  if(!window.forms_i18n) {
    console.warn('Translation object "window.forms_i18n" is not defined.');
    return defaultValue || key;
  }
  const value = window.forms_i18n[key];
  if (value === undefined) {
    console.warn(`Missing translation for key: ${key}`);
    return defaultValue || key;
  }
  return value;
}
